import * as React from 'react'
import Card from '@mui/material/Card'
import { Chart } from 'chart.js/auto'
import { BarController, Tooltip } from 'chart.js'
import { Bar } from 'react-chartjs-2'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import { Box, Button } from '@mui/material'
import Translations from 'src/@core/layouts/components/Translations'
import { useRouter } from 'next/router'
import { LandState, RainCardInformation } from 'src/@types'
import RainsEmptyCard from '../rains-empty-card'

Chart.register(BarController, Tooltip)

interface RainsCardProps {
  landId: number
  information?: RainCardInformation
  status: LandState
}

export default function RainsCard({ landId, information, status }: RainsCardProps) {
  const router = useRouter()
  const monthName = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(new Date())
  const colors = ['#CAAA70', '#526378']

  const handleRedirectToRains = () => {
    router.push(`/lands/details/rains/${landId}`)
  }
  let labels: string[] = []
  if (information) {
    labels = [`${information.actualAcumulatedRain.toFixed(0)} mm`, `${information?.averageAcumulatedRain?.toFixed(0) || 0} mm`]
  }

  return information ? (
    <Card
      className='rains-card'
      sx={{
        minWidth: '250px',
        height: '260px',
        alignItems: 'center',
        borderRadius: '20px',
        backgroundColor: 'white',
      }}
    >
      <CardContent
        className='card-medio'
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}
        >
          <Typography
            sx={{ fontSize: '18px', fontWeight: '700', color: 'black', textAlign: 'center' }}
            className='cards-title'
          >
            <Translations text={'Rain historic'} />
          </Typography>
          <Typography sx={{ fontSize: '14px', fontWeight: '400', color: 'black', textAlign: 'center' }}>
            <Translations text={monthName} />
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-evenly' }}>
          <Box
            sx={{
              display: 'flex',
              height: '100%',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Typography sx={{ fontSize: '14px', fontWeight: '400', textAlign: 'center' }}>
              <Translations text={'Actual'} />
            </Typography>
            <Typography sx={{ fontSize: '14px', fontWeight: '400', textAlign: 'center' }}>
              <Translations text={'accumulated'} />
            </Typography>
            <Typography sx={{ fontSize: '16px', fontWeight: '700', textAlign: 'center', color: '#CAAA70' }}>
              {information.actualAcumulatedRain.toFixed(0) + 'mm'}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              height: '100%',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: '100px%',
              minHeight: '100px',
              maxWidth: '100px',
              maxHeight: '100px'
            }}
          >
            <Bar
              data={{
                labels: labels,
                datasets: [
                  {
                    data: [information.actualAcumulatedRain, information.averageAcumulatedRain],
                    backgroundColor: colors,
                    borderColor: colors,
                    barThickness: 15,
                    borderSkipped: false
                  }
                ]
              }}
              options={{
                color: 'black',
                responsive: true,
                plugins: {
                  legend: {
                    display: false,
                    labels: {
                      font: {
                        size: 5
                      }
                    }
                  }
                },
                scales: {
                  x: {
                    display: false,
                    border: { display: false },
                    ticks: { color: 'black' }
                  },
                  y: {
                    display: false,
                    beginAtZero: true,
                    ticks: { display: false },
                    border: { display: false }
                  }
                }
              }}
              width={'70px'}
              height={'100px'}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              height: '100%',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Typography sx={{ fontSize: '14px', fontWeight: '400', textAlign: 'center' }}>
              <Translations text={'Average'} />
            </Typography>
            <Typography sx={{ fontSize: '14px', fontWeight: '400', textAlign: 'center' }}>
              <Translations text={'accumulated'} />
            </Typography>
            <Typography sx={{ fontSize: '16px', fontWeight: '700', textAlign: 'center', color: '#526378' }}>
              {information?.averageAcumulatedRain?.toFixed(0) + 'mm'}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', w: '100%', alignItems: 'center', mt: 'auto' }}>
          <Button
            variant='outlined'
            sx={{
              color: '#213D36',
              width: '123px',
              padding: '8px, 12px, 8px, 12px',
              fontSize: '16px',
              fontWeight: 700,
              borderRadius: '30px',
              border: '3px solid #213D36'
            }}
            onClick={handleRedirectToRains}
          >
            <Translations text={'DETAILS'} />
          </Button>
        </Box>
      </CardContent>
    </Card>
  ) : (
    <RainsEmptyCard landId={landId} status={status} />
  )
}
